// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardBox-root-0642b753c5a8e162bdc7bb3abd19f07a"};